import { http } from '../http'
import userGWFragments from '@shared/hooks/usegwFragments'

export const getDeletedOrder = async ({
  orderNo,
  description,
}: {
  orderNo: string
  description: string
}): Promise<any[]> => {
  const userFragments = userGWFragments()
  const { data } = await http.post<any>(
    `gateway/${userFragments.customerNo}/inquiry`,
    {
      url: '/ib/order/card/salary/delete',
      data: {
        ...userFragments,
        orderNo,
        description,
      },
    }
  )

  if (data.data.code !== 200) {
    throw new Error(data.data.message)
  }

  return data.data.data
}
